import { styled } from '@mui/material';
import { MOBILE_SCREEN_SIZE, TABLET_SCREEN_SIZE } from '../../utils/constants';

export const ProductGrid = styled('div', {
  shouldForwardProp: (prop) => !['containerWidthOverride'].includes(prop.toString()),
})<{ containerWidthOverride?: boolean }>(({ containerWidthOverride }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${containerWidthOverride ? 4 : 5}, 1fr)`,
  justifyContent: 'space-between',
  gridGap: 20,
  [`@media screen and (max-width: ${1450}px)`]: {
    gridTemplateColumns: `repeat(4, 1fr)`,
  },
  [`@media screen and (max-width: ${1150}px)`]: {
    gridTemplateColumns: `repeat(3, 1fr)`,
  },
  [`@media screen and (max-width: ${(TABLET_SCREEN_SIZE + MOBILE_SCREEN_SIZE) / 2}px)`]: {
    gridTemplateColumns: `repeat(2, 1fr)`,
    gridGap: 10,
  },
}));
